<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconChevronDown_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="m11.293 15.207-5-5a.999.999 0 1 1 1.414-1.414L12 13.086l4.293-4.293a.999.999 0 1 1 1.414 1.414l-5 5a.999.999 0 0 1-1.414 0Z"
    />
</svg>
